import {
  getType
} from '@/assets/js/pcMobile.js'

window.onresize = function() {
  setRem();
};

function setRem() {
  let flag = getType()
  var bodyWidth = document.body.clientWidth; // 当前窗口的宽度
  if (flag == 'pc') {
    if (bodyWidth >= 980) {
      var whdef = 100 / 1920; // 表示1920的设计图,使用100PX的默认值
    } else {
      var whdef = 100 / 750; // 表示750的设计图,使用100PX的默认值
    }
  } else {
    var whdef = 100 / 750; // 表示750的设计图,使用100PX的默认值
  }

  // if (bodyWidth >= 1366) {
  //   var whdef = 100 / 1920; // 表示1920的设计图,使用100PX的默认值
  //   if (bodyWidth <= 1366) {
  //     bodyWidth = 1366
  //   }
  // } else {
  //   var whdef = 100 / 750; // 表示750的设计图,使用100PX的默认值
  // }
  var rem = bodyWidth * whdef; // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
  document.getElementsByTagName('html')[0].style.fontSize = rem + 'px';
}

window.addEventListener('load', setRem);
window.addEventListener('resize', setRem);



// WEBPACK FOOTER //
// ./src/assets/js/rem.js